"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./utils");

var _TinyMCE = _interopRequireDefault(require("./Components/TinyMCE"));

var _Placeholder = _interopRequireDefault(require("./Components/Placeholder"));

var TinyMceContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TinyMceContainer, _Component);

  function TinyMceContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TinyMceContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinyMceContainer).call(this, props));
    _this.state = {
      showPlaceholder: props.placeholderText && !props.content
    };
    _this.throttledSetShowPlaceholder = (0, _utils.throttle)(_this.setShowPlaceholder, 500, (0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TinyMceContainer, [{
    key: "handleChange",
    value: function handleChange(event, editor) {
      if (this.props.placeholderText) {
        this.throttledSetShowPlaceholder(editor);
      }

      if (this.props.onChange) {
        this.props.onChange(event, editor);
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(event, editor) {
      if (this.props.placeholderText) {
        this.throttledSetShowPlaceholder(editor);
      }

      if (this.props.onKeyUp) {
        this.props.onKeyUp(event, editor);
      }
    }
  }, {
    key: "setShowPlaceholder",
    value: function setShowPlaceholder(editor) {
      var shouldShowPlaceholder = editor.getContent() === '';

      if (shouldShowPlaceholder !== this.state.showPlaceholder) {
        this.setState({
          showPlaceholder: shouldShowPlaceholder
        });
      }
    }
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      var _this$props = this.props,
          config = _this$props.config,
          placeholderClassName = _this$props.placeholderClassName,
          placeholderText = _this$props.placeholderText;
      return config.inline ? _react.default.createElement(_Placeholder.default, {
        showPlaceholder: this.state.showPlaceholder,
        className: placeholderClassName,
        text: placeholderText
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          placeholderText = _this$props2.placeholderText,
          __placeholderClassName = _this$props2.placeholderClassName,
          tinyMceRef = _this$props2.tinyMceRef,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["placeholderText", "placeholderClassName", "tinyMceRef"]);
      return _react.default.createElement("div", {
        className: "react-tinymce-root",
        style: {
          position: 'relative',
          outline: 'none'
        }
      }, placeholderText && this.renderPlaceholder(), _react.default.createElement(_TinyMCE.default, (0, _extends2.default)({}, rest, {
        ref: tinyMceRef,
        onChange: this.handleChange,
        onKeyUp: this.handleKeyUp
      })));
    }
  }]);
  return TinyMceContainer;
}(_react.Component);

TinyMceContainer.propTypes = (0, _extends2.default)({
  placeholderText: _react.PropTypes.string,
  placeholderClassName: _react.PropTypes.string,
  tinyMceRef: _react.PropTypes.func
}, _TinyMCE.default.propTypes);
TinyMceContainer.defaultProps = {
  tinyMceRef: function tinyMceRef() {}
};
var _default = TinyMceContainer;
exports.default = _default;
module.exports = exports.default;